// context/codeConfig.js
import React, { createContext, useContext } from 'react';

// Code Projects data - easily editable
const codeProjectsData = [
    // life os
    {
        id: "lifeos",
        title: "LifeOS",
        year: "2025",
        type: "private",
        category: "React Web-app",
        description: "code_lifeos_description",
        longDescription: "code_lifeos_longDescription",
        technologies: ["React", "Tailwind CSS", "External API Key", "Vercel", "PostgreSQL"],
        features: [
            "code_lifeos_feature1",
            "code_lifeos_feature2",
            "code_lifeos_feature3",
            "code_lifeos_feature4",
        ],
        githubUrl: "",
        liveUrl: "",
        mainImage: "/img/code/lifeos_hero.png",
        gallery: [
            { type: "image", url: "/img/code/lifeos-0.png", caption: "code_lifeos_gallery1_caption" },
            { type: "image", url: "/img/code/lifeos-2.png", caption: "code_lifeos_gallery2_caption" },
            { type: "image", url: "/img/code/lifeos-3.png", caption: "code_lifeos_gallery3_caption" },
            { type: "image", url: "/img/code/lifeos-1.png", caption: "code_lifeos_gallery4_caption" }
        ],
        techStack: {
            frontend: ["React", "Tailwind CSS", "PWA", "R3F"],
            backend: ["Vercel Serverless Functions", "Supabase", "PostgreSQL"],
            integrations: ["Strava API", "Apple Health", "Telegram Webhooks"]
        }
    },
    // spese tracker
    {
        id: "family-expenses",
        title: "Family Expense Sharing - Spese Comuni",
        year: "2024",
        type: "private",
        category: "React Web-app",
        description: "code_expenses_description",
        longDescription: "code_expenses_longDescription",
        technologies: ["React", "Tailwind CSS", "Supabase", "PostgreSQL", "Vercel"],
        features: [
            "code_expenses_feature1",
            "code_expenses_feature2",
            "code_expenses_feature3",
            "code_expenses_feature4",
            "code_expenses_feature5",
            "code_expenses_feature6"
        ],
        githubUrl: "",
        liveUrl: "https://demoah-giupalla.vercel.app/",
        iframeUrl: "https://demoah-giupalla.vercel.app/",
        mainImage: "/img/code/expenses-main.png",
        challenges: "code_expenses_challenges",
        techStack: {
            frontend: ["React", "Tailwind CSS", "PWA"],
            backend: ["Supabase", "PostgreSQL", "Authentication"],
            devops: ["Vercel", "Edge Functions"]
        }
    },
    // blender addons
    {
        id: "blender-studio-tools",
        title: "Blender Studio Tools",
        year: "2023",
        type: "public",
        category: "Blender Addon",
        description: "code_blender_description",
        longDescription: "code_blender_longDescription",
        technologies: ["Python", "Blender API"],
        features: [
            "code_blender_feature1",
            "code_blender_feature2",
            "code_blender_feature3",
            "code_blender_feature4",
            "code_blender_feature5",
            "code_blender_feature6"
        ],
        githubUrl: "https://github.com/paolowu5/blender-quick-studio",
        liveUrl: "",
        mainImage: "/img/code/blender-main.png",
        gallery: [
            { type: "image", url: "/img/code/blender-1.png", caption: "code_blender_gallery1_caption" },
            { type: "image", url: "/img/code/blender-2.png", caption: "code_blender_gallery2_caption" }
        ],
        codeSnippets: [
            {
                title: "Viewport to Camera Matrix Conversion",
                language: "python",
                code: `def execute(self, context):
    # Capture current viewport state
    region_3d = context.space_data.region_3d
    view_matrix = region_3d.view_matrix.copy()

    # Create camera with unique name
    camera_name = self.get_unique_camera_name()
    camera_data = bpy.data.cameras.new(name=camera_name)
    camera_object = bpy.data.objects.new(name=camera_name, object_data=camera_data)

    # Position camera to match view
    camera_object.matrix_world = view_matrix.inverted()
    context.scene.camera = camera_object`
            }
        ],
        challenges: "code_blender_challenges",
        techStack: {
            language: ["Python 3.x", "Blender Python API"],
            platform: ["Blender 3.0+", "Cross-platform"],
            features: ["Matrix Transformations", "Constraint Systems", "Custom UI Panels"]
        }
    },
    // trellis 3d generator
    {
        id: "trellis-3d-generator",
        title: "Trellis 3D Blender Addon",
        year: "2025",
        type: "public",
        category: "Blender Addon",
        description: "code_trellis_description",
        longDescription: "code_trellis_longDescription",
        technologies: ["Python", "Blender API", "Trellis", "Gradio"],
        features: [
            "code_trellis_feature1",
            "code_trellis_feature2",
            "code_trellis_feature3",
            "code_trellis_feature4",
            "code_trellis_feature5",
            "code_trellis_feature6",
        ],
        githubUrl: "https://github.com/paolowu5/trellis-addon",
        liveUrl: "",
        mainImage: "/img/code/trellis-main.png",
        gallery: [
            { type: "image", url: "/img/code/trellis-0.png", caption: "code_trellis_gallery1_caption" },
            
        ],
        challenges: "code_trellis_challenges",
        techStack: {
            language: ["Python 3.x", "Blender Python API"],
            platform: ["Blender 3.6+", "NVIDIA GPU (VRAM ≥ 8 GB recommended)"],
            integrations: ["Microsoft Trellis", "Gradio Client", "psutil", "pynvml"]
        }
    },
    // diffusion bot
    {
        id: "diffusion-bot",
        title: "Diffusion Bot",
        year: "2022",
        type: "public",
        category: "Discord AI Image Generation Bot",
        description: "code_diffusion_description",
        longDescription: "code_diffusion_longDescription",
        technologies: ["Python", "Discord.py", "Stable Diffusion WebUI", "ControlNet"],
        features: [
            "code_diffusion_feature1",
            "code_diffusion_feature2",
            "code_diffusion_feature3",
            "code_diffusion_feature4",
            "code_diffusion_feature5",
            "code_diffusion_feature6",
        ],
        githubUrl: "https://github.com/paolowu5/stable-diffusion-discord-bot",
        liveUrl: "https://diffusion-website.pages.dev/",
        mainImage: "/img/code/diffusion-main.png",
        gallery: [
            { type: "image", url: "/img/code/diffusion-1.png", caption: "code_diffusion_gallery1_caption" },
        ],
        codeSnippets: [
            {
                title: "Discord Slash Command Handler",
                language: "python",
                code: `    async with aiohttp.ClientSession() as session:
        async with session.post(url=f'{url}/sdapi/v1/txt2img', json=payload) as response:
            data = await response.json()

    images = []
    for i in data['images']:
        image = Image.open(io.BytesIO(base64.b64decode(i.split(",", 1)[0])))
        images.append(image)
    grid_size = (2, 2)
    result_image = create_grid_image(images, grid_size)`
            }
        ],
        techStack: {
            backend: ["Python 3.8+", "Discord.py", "Stable Diffusion WebUI API"],
            ai: ["Stable Diffusion", "ControlNet"],
            tools: ["Pillow", "aiohttp", "Requests"]
        }
    },
    // lazy slideshow
    {
        id: "lazy-slideshow",
        title: "Lazy Slideshow",
        year: "2022",
        type: "public",
        category: "After Effects Script",
        description: "code_lazy_description",
        longDescription: "code_lazy_longDescription",
        technologies: ["ExtendScript", "Adobe After Effects", "JavaScript"],
        features: [
            "code_lazy_feature1",
            "code_lazy_feature2",
            "code_lazy_feature3",
            "code_lazy_feature4",
            "code_lazy_feature5",
            "code_lazy_feature6"
        ],
        githubUrl: "https://github.com/paolowu5/after-effects-lazy-slideshow",
        liveUrl: "https://lazyslideshow.pages.dev/",
        mainImage: "/img/code/lazy-main.png",
        video: "https://www.montevulture.it/varie/video/lazy.mp4",
        challenges: "code_lazy_challenges",
        techStack: {
            language: ["ExtendScript (JavaScript for Adobe)"],
            platform: ["Adobe After Effects CC 2018+"],
            deployment: ["ScriptUI Panel", "Standalone Script"]
        },
        additionalLinks: {
            gumroad: "https://3156877858949.gumroad.com/l/lazyslideshow"
        }
    }
];

// Create the context
const CodeProjectsContext = createContext();

// Provider component
export const CodeProjectsProvider = ({ children }) => {
    const value = {
        projects: codeProjectsData,
        getProjectById: (id) => codeProjectsData.find(project => project.id === id),
        getNextProject: (id) => {
            const currentIndex = codeProjectsData.findIndex(project => project.id === id);
            const nextIndex = (currentIndex + 1) % codeProjectsData.length;
            return codeProjectsData[nextIndex];
        },
        getPreviousProject: (id) => {
            const currentIndex = codeProjectsData.findIndex(project => project.id === id);
            const prevIndex = currentIndex === 0 ? codeProjectsData.length - 1 : currentIndex - 1;
            return codeProjectsData[prevIndex];
        }
    };

    return (
        <CodeProjectsContext.Provider value={value}>
            {children}
        </CodeProjectsContext.Provider>
    );
};

// Custom hook to use the code projects context
export const useCodeProjects = () => {
    const context = useContext(CodeProjectsContext);
    if (context === undefined) {
        throw new Error('useCodeProjects must be used within a CodeProjectsProvider');
    }
    return context;
};

// Direct export of the data
export const codeProjects = codeProjectsData;
